module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcarm1-c52772d5125b0d38a0b02d3ddb2870ff.jpg";